import React from 'react';
import Loader from 'relements/build/esm/ui/loader';

import styles from './Loading.scss';

function Loading() {
  return (
    <div className={styles.loading}>
      <Loader />
      <div className={styles.loadingTitle}>Searching</div>
      <div className={styles.loadingSubtitle}>
        Please wait while we search for your query
      </div>
    </div>
  );
}

Loading.propTypes = {};
Loading.defaultProps = {};

export default Loading;
